import * as i0 from '@angular/core';
import { ChangeDetectorRef, Injectable, Inject, Self, ElementRef, Directive, Input, HostBinding, HostListener, NgModule } from '@angular/core';
import { IntersectionObserverService } from '@ng-web-apis/intersection-observer';
import { tuiWatch, TuiDestroyService } from '@taiga-ui/cdk';
import * as i1 from 'rxjs';
import { Observable, of, Subject } from 'rxjs';
import { switchMap, filter, map, catchError, take, takeUntil } from 'rxjs/operators';
let TuiLazyLoadingService = /*#__PURE__*/(() => {
  class TuiLazyLoadingService extends Observable {
    constructor(cdr, destroy$, intersections$) {
      super(subscriber => this.src$.pipe(switchMap(src => intersections$.pipe(filter(([{
        isIntersecting
      }]) => isIntersecting), map(() => src), catchError(() => of(src)), tuiWatch(cdr), take(1))), takeUntil(destroy$)).subscribe(subscriber));
      this.src$ = new Subject();
    }
    next(src) {
      this.src$.next(src);
    }
  }
  TuiLazyLoadingService.ɵfac = function TuiLazyLoadingService_Factory(t) {
    return new (t || TuiLazyLoadingService)(i0.ɵɵinject(ChangeDetectorRef), i0.ɵɵinject(TuiDestroyService, 2), i0.ɵɵinject(IntersectionObserverService));
  };
  TuiLazyLoadingService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TuiLazyLoadingService,
    factory: TuiLazyLoadingService.ɵfac
  });
  return TuiLazyLoadingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiLazyLoadingDirective = /*#__PURE__*/(() => {
  class TuiLazyLoadingDirective {
    constructor(src$, el) {
      this.src$ = src$;
      this.el = el;
      this.animation = 'tuiSkeletonVibe ease-in-out 1s infinite alternate';
      this.background = 'var(--tui-clear-hover)';
      this.src = null;
      if (!this.supported) {
        this.src$.subscribe(src => {
          this.src = src;
        });
      }
    }
    set srcSetter(src) {
      this.src = this.supported ? src : null;
      this.src$.next(src);
    }
    get supported() {
      return 'loading' in this.el.nativeElement;
    }
    onLoad() {
      this.background = '';
      this.animation = '';
    }
  }
  TuiLazyLoadingDirective.ɵfac = function TuiLazyLoadingDirective_Factory(t) {
    return new (t || TuiLazyLoadingDirective)(i0.ɵɵdirectiveInject(TuiLazyLoadingService), i0.ɵɵdirectiveInject(ElementRef));
  };
  TuiLazyLoadingDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiLazyLoadingDirective,
    selectors: [["img", "loading", "lazy"]],
    hostVars: 5,
    hostBindings: function TuiLazyLoadingDirective_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("load", function TuiLazyLoadingDirective_load_HostBindingHandler() {
          return ctx.onLoad();
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("src", ctx.src, i0.ɵɵsanitizeUrl);
        i0.ɵɵstyleProp("animation", ctx.animation)("background", ctx.background);
      }
    },
    inputs: {
      srcSetter: ["src", "srcSetter"]
    },
    features: [i0.ɵɵProvidersFeature([TuiLazyLoadingService, IntersectionObserverService, TuiDestroyService])]
  });
  return TuiLazyLoadingDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiLazyLoadingModule = /*#__PURE__*/(() => {
  class TuiLazyLoadingModule {}
  TuiLazyLoadingModule.ɵfac = function TuiLazyLoadingModule_Factory(t) {
    return new (t || TuiLazyLoadingModule)();
  };
  TuiLazyLoadingModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TuiLazyLoadingModule
  });
  TuiLazyLoadingModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return TuiLazyLoadingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiLazyLoadingDirective, TuiLazyLoadingModule, TuiLazyLoadingService };
